import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';

const variants = {
	classic: { className: 'auth-classic' },
	'with-box': { className: 'auth-with-box' },
	'with-image': { className: 'auth-with-box auth-with-media', media: true },
	'full-screen': { className: 'auth-with-box auth-with-media auth-full-screen', media: true },
	'cover-bg': { className: 'auth-with-cover', cover: true, dark: true }
};

function AuthShell({ variant, children }) {
	const context = useContext(AppSettings);
	const currentVariant = variants[variant] || variants.classic;
	const mode = children?.props?.mode;
	const isSignIn = mode === 'sign-in';
	const isSignUp = mode === 'sign-up';
	const isLockScreen = mode === 'lock-screen';
	const isEmailSent = mode === 'email-sent';
	const isWithImage = variant === 'with-image';
	const isFullScreen = variant === 'full-screen';
	const isMediaVariant = isWithImage || isFullScreen;
	const authClass = [
		currentVariant.className,
		variant === 'with-image' && isSignUp ? 'py-5 overflow-hidden vh-100' : '',
		variant === 'full-screen' && isSignUp ? 'overflow-hidden vh-100' : ''
	].filter(Boolean).join(' ');
	const containerClass = [
		variant === 'classic' && mode !== 'sign-in' ? 'my-5' : '',
		variant === 'classic' && isLockScreen ? 'pt-5' : '',
		variant === 'with-box' && !isEmailSent ? 'my-5' : '',
		variant === 'with-box' && isLockScreen ? 'pt-5' : '',
		isWithImage && !isSignIn && !isSignUp ? 'my-5' : '',
		isMediaVariant && isSignUp ? 'h-100' : '',
		variant === 'cover-bg' && mode !== 'sign-in' ? 'my-5' : '',
		variant === 'cover-bg' && isLockScreen ? 'pt-5' : '',
		variant === 'cover-bg' ? 'text-white' : ''
	].filter(Boolean).join(' ');
	const contentClass = [
		'auth-content',
		isEmailSent && variant !== 'classic' ? 'text-center' : '',
		isMediaVariant && isLockScreen ? 'pt-5' : '',
		isFullScreen && isSignUp ? 'd-block' : ''
	].filter(Boolean).join(' ');
	const contentScrollable = isMediaVariant && isSignUp;

	useEffect(() => {
		context.handleSetAppHeaderNone(true);
		context.handleSetAppSidebarNone(true);
		context.handleSetAppClass('app-full-height app-without-header');
		context.handleSetAppContentClass('p-0');
		return () => {
			context.handleSetAppHeaderNone(false);
			context.handleSetAppSidebarNone(false);
			context.handleSetAppClass('');
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className={`auth ${authClass}`} data-bs-theme={currentVariant.dark ? 'dark' : undefined}>
			{currentVariant.cover && <div className="auth-cover"><img src="/color-admin/admin/react/assets/img/auth/media-1.jpg" alt="" className="object-fit-cover" /><div className="position-absolute top-0 start-0 w-100 h-100 bg-gray-900 bg-opacity-75"></div></div>}
			<div className={`auth-container ${containerClass}`}>
				{currentVariant.media && <div className="auth-media"><img src="/color-admin/admin/react/assets/img/auth/media-1.jpg" className="auth-media-img object-fit-cover" alt="" /><div className="auth-media-content bg-gray-900 bg-opacity-50 p-4 d-flex align-items-end" data-bs-theme="dark"><iconify-icon icon="solar:lock-password-bold-duotone" className="position-absolute top-0 start-0 p-4 opacity-5 z-3 text-white display-4"></iconify-icon><div><h4 className="fw-bold">Everything Starts Here.</h4><p className="fs-6 text-body text-opacity-75 mb-1">With one secure login, you unlock all our services. One account, infinite access — made simple for you.</p></div></div></div>}
				<div className={contentClass} {...(contentScrollable ? { 'data-scrollbar': 'true' } : {})}>{children}</div>
			</div>
		</div>
	);
}

export default AuthShell;
